import { useCatalogSectionNavigation } from './useCatalogSectionNavigation';

interface CatalogEditorNavigationProps {
  isProduct: boolean;
  hasImages: boolean;
}

export function CatalogEditorNavigation({ isProduct, hasImages }: CatalogEditorNavigationProps) {
  const { activeSection, setActiveSection } = useCatalogSectionNavigation(hasImages);
  return (
    <nav className="catalog-editor-nav" aria-label="Разделы формы">
      <p>На этой странице</p>
      <a href="#identity" aria-current={activeSection === 'identity' ? 'location' : undefined} onClick={() => setActiveSection('identity')}>Основное</a>
      <a href="#classification" aria-current={activeSection === 'classification' ? 'location' : undefined} onClick={() => setActiveSection('classification')}>{isProduct ? 'Категория и учёт' : 'Место в каталоге'}</a>
      {hasImages ? <a href="#photos" aria-current={activeSection === 'photos' ? 'location' : undefined} onClick={() => setActiveSection('photos')}>Фотографии</a> : null}
    </nav>
  );
}
